
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const popularProductsWidgetsData = data;
  store.dispatch('fetchPopularProductsDataWidgets', popularProductsWidgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default (filter = 'last_3_months') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`user-widgets/popular-products/${filter}`)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchPopularProductsWidgets.js